import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MemberShipSection from './subviews/membershipSection/MemberShipSection';
import PersonalInfoSection from './subviews/personalInfoSection/PersonalInfoSection';
import CommAndLangSection from './subviews/commAndLangSection/CommAndLangSection';
import PasswordSection from './subviews/passwordSection/PasswordSection';
import './Profile.scss';
import { MembershipTier, MemberProfile } from 'types/dto/profile';
import { fetchProfile, fetchTier } from 'services/profileService';
import { message, Skeleton } from 'antd';
import { useSession } from 'context/SessionContext';

const Profile: React.FC = () => {
  const { t } = useTranslation('profile');
  const { t: tCommon } = useTranslation('common');
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = React.useState(false);
  const [profile, setProfile] = useState<MemberProfile>();
  const [membershipData, setMembershipData] = useState<MembershipTier>();
  const {session, setSession} = useSession();

  const refreshProfile = useCallback(async () => {
    try {
      // const sessionInfo: SessionInfo = {
      //   sessionID: session?._tk || '',
      //   juicyAppUniqueId: session?._id || '',
      //   customerName: session?._n1 || '',
      //   customerNameZh: session?._n2 || '',
      //   preflang: session?._lg || '',
      //   lastPickUpMethodCode: session?._pu || '',
      //   needTnC: session?._tc || false,
      //   isPasswordCreated: session?._vp || false,
      //   isEmailVerified: session?._ve || false,
      //   parameterCount: 0,
      //   status: session?._st || 'new'
      // };
      const profileData: MemberProfile = await fetchProfile('/profile');

      setProfile(profileData);

      if (session) {
        setSession({
          ...session,
          // _n1: `${profileData.loyalty_account.first_name} ${profileData.loyalty_account.last_name}`.trim()
        });
      }

    } catch (err) {
      message.error(tCommon('error.loadDataError'));
    }
  }, [session, tCommon]);

  const refreshData = useCallback(async () => {
    try {
      setIsLoading(true);

      // Fetch profile data
      // const sessionInfo: SessionInfo = {
      //   sessionID: session?._tk || '',
      //   juicyAppUniqueId: session?._id || '',
      //   customerName: session?._n1 || '',
      //   customerNameZh: session?._n2 || '',
      //   preflang: session?._lg || '',
      //   lastPickUpMethodCode: session?._pu || '',
      //   needTnC: session?._tc || false,
      //   isPasswordCreated: session?._vp || false,
      //   isEmailVerified: session?._ve || false,
      //   parameterCount: 0,
      //   status: session?._st || 'new',
      // };
      const profileData: MemberProfile = await fetchProfile(
        '/profile',
        // sessionInfo,
      );
      setProfile(profileData);

      // Fetch tier data
      // console.log('session is ', session);
      const tierData = await fetchTier('/profile');
      setMembershipData(tierData);

      setLoadError(false);
    } catch (err) {
      setLoadError(true);
      console.error('Failed to obtain the service type:', err);
    } finally {
      setIsLoading(false);
    }
  }, [session]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div className="profile-container">
      <div
        className="profile-header"
        style={{ backgroundColor: membershipData?.current_tier.color }}
      ></div>
      <div className="profile-content">
        <div className="profile-title">{t('title')}</div>

        {/* Show loading skeleton overlay while data is loading */}
        {isLoading && (
          <div className="skeleton-card">
            <Skeleton active paragraph={{ rows: 4 }} />
          </div>
        )}

        {/* Show error alert if loading failed */}
        {!isLoading && loadError && (
          <div className="load-data-error">
            {tCommon('error.loadDataError')}
          </div>
        )}

        {!isLoading && !loadError && (
          <>
            {/* Membership Card Section */}
            {membershipData && (
              <MemberShipSection membershipData={membershipData} />
            )}

            {/* Personal Information Section */}
            <PersonalInfoSection
              loyaltyAccount={profile?.loyalty_account}
              onSaveCallback={refreshProfile}
            />

            {/* Communication and Language Preferences Section */}
            <CommAndLangSection
              profile={profile}
              onSaveCallback={refreshProfile}
            />

            {/* Change Password Section */}
            <PasswordSection profile={profile}/>
          </>
        )}
      </div>
    </div>
  );
};

export default Profile;
